export const GET_ROOM_PRICE_TYPES = 'GET_ROOM_PRICE_TYPES';
export const GET_ROOM_PRICE_TYPES_SUCCESS = 'GET_ROOM_PRICE_TYPES_SUCCESS';
export const GET_ROOM_PRICE_TYPES_FAILED = 'GET_ROOM_PRICE_TYPES_FAILED';

export const GET_PLACE_OTA_DATA = 'GET_PLACE_OTA_DATA';
export const GET_PLACE_OTA_DATA_SUCCESS = 'GET_PLACE_OTA_DATA_SUCCESS';
export const GET_PLACE_OTA_DATA_FAILED = 'GET_PLACE_OTA_DATA_FAILED';

export const UPDATE_ROOM_PRICE_TYPES = 'UPDATE_ROOM_PRICE_TYPES';
export const UPDATE_ROOM_PRICE_TYPES_SUCCESS = 'UPDATE_ROOM_PRICE_TYPES_SUCCESS';
export const UPDATE_ROOM_PRICE_TYPES_FAILED = 'UPDATE_ROOM_PRICE_TYPES_FAILED';
